import { Loader } from 'rsuite';

export default function ProviderBadge({ provider, isLoading }) {
  if (isLoading) {
    return (
      <span
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 8,
          padding: '2px 8px',
          borderRadius: 999,
          border: '1px solid #e6e6e6',
          background: '#fafafa',
          fontSize: 12,
          color: '#666',
          whiteSpace: 'nowrap',
        }}
      >
        <Loader size="xs" />
        <span>Loading provider…</span>
      </span>
    );
  }

  const name = provider?.displayName || provider?.name || null;

  if (!name) {
    return (
      <span
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 6,
          padding: '2px 8px',
          borderRadius: 999,
          border: '1px solid #e6e6e6',
          background: '#fffbe6',
          fontSize: 12,
          color: '#8c6d1f',
          whiteSpace: 'nowrap',
        }}
        title="No hours provider configured"
      >
        <i className="bi bi-exclamation-triangle-fill" aria-hidden="true" />
        <span>No provider configured</span>
      </span>
    );
  }

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        padding: '2px 8px',
        borderRadius: 999,
        border: '1px solid #e6e6e6',
        background: '#fafafa',
        fontSize: 12,
        color: '#666',
        whiteSpace: 'nowrap',
      }}
      title={`Data from: ${name}`}
    >
      <i className="bi bi-database" aria-hidden="true" />
      <span>
        Data from: <span style={{ fontWeight: 700, color: '#2e2e2e' }}>{name}</span>
      </span>
    </span>
  );
}
